import '@d3fc/d3fc-element';
import { candlestick } from 'utils/components/TimeSeriesChart/candlestick';
import {
    deriveCandleClose,
    deriveCandleHigh,
    deriveCandleLow,
    deriveCandleOpen,
    OrderFill,
} from 'widgets/fillsGraph/fillsGraphData';

export const priceCandlesSeries = candlestick<OrderFill>(
    deriveCandleOpen,
    deriveCandleHigh,
    deriveCandleLow,
    deriveCandleClose,
    'candlestick price-candles',
    (d) => d.bucket?.candle && d.bucket?.midTime
);
